<template>
  <div>
    <form @submit.prevent="onSubmit" class="mb-2">
      <div class="input-group">
        <input class="form-control"
          v-validate="'required|min:3'"
          v-bind:placeholder="searchModeObj[searchMode]['placeholder']"
          name="searchName"
          v-bind:data-vv-as="searchModeObj[searchMode]['fieldName']"
          v-model="searchName">
        <div class="input-group-append">
          <b-button @click="onSubmit">Search</b-button>
        </div>
      </div>
      <div class="invalid-feedback d-block">{{ errors.first('searchName') }}</div>
    </form>
    <ul class="list-group border border-dark bg-white rounded results noselect mb-2">
      <div v-if="searchResult.length == 0 && !loadingResults"
        class="d-flex align-items-center justify-content-center placeholder">
        No Results
      </div>
      <LoadingSpinner v-if="loadingResults" message ='' size = '1x'>
      </LoadingSpinner>
      <template v-if="!loadingResults">
        <router-link v-for="result in searchResult"
          :key="result.id"
          class="list-group-item list-group-item-action
          btn d-flex justify-content-between align-items-center py-1"
          :to="{ name: searchModeObj[searchMode].routeName,
          params: returnParam(result) }">
          <span class="text-primary text-left">{{result.id}} - {{result.name}}</span>
          <img class="ml-2" src="../assets/ButtonArrow.svg" height="25" alt="arrow button">
        </router-link>
      </template>
    </ul>
    <div v-if="resultLimitExceeded" class="alert alert-secondary">
      Your search returned more than 10 results. If your Project is not in this list, please use
       Advanced Search.
    </div>
  </div>
</template>

<script>
import api from '../api';
import LoadingSpinner from './LoadingSpinner.vue';

export default {
  name: 'QuickSearch',
  props: {
    searchMode: {
      type: String,
      default: 'projectName',
    },
  },
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      serverError: null,
      searchName: null,
      searchResult: [],
      loadingResults: false,
      resultLimitExceeded: false,
      searchModeObj: {
        projectName: {
          placeholder: 'Enter Project Name',
          fieldName: 'Project Name',
          entityType: 'project',
          routeName: 'project',
        },
        propertyName: {
          placeholder: 'Enter Property Name',
          fieldName: 'Property Name',
          entityType: 'property',
          routeName: 'projectProperty',
          paramName: 'property_id',
        },
      },
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validate()
        .then((result) => {
          if (result) {
            this.loadingResults = true;
            api.get(`/${this.searchModeObj[this.searchMode].entityType}/searchByName?name=${this.searchName}`)
              .then((response) => {
                this.searchResult = response.data.results;
                this.resultLimitExceeded = response.data.resultLimitExceeded;
                this.loadingResults = false;
              });
          }
        });
    },
    returnParam(result) {
      const paramObj = {};
      if (this.searchModeObj[this.searchMode].paramName) {
        paramObj.project_id = parseInt(result.projectId, 10);
        paramObj[this.searchModeObj[this.searchMode].paramName] = parseInt(result.id, 10);
      } else {
        paramObj.project_id = parseInt(result.id, 10);
      }
      return paramObj;
    },
  },
};
</script>
